import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Component({
  selector: 'va-cta-dialog',
  templateUrl: './get-pro-dialog.component.html',
  styleUrls: ['./get-pro-dialog.component.scss'],
})
export class UpgradeCTADialogComponent {
  public isLoading = false;
  public hasActiveOrder = false;

  sanitizedSellingPoints: string[];

  constructor(
    public dialogRef: MatDialogRef<UpgradeCTADialogComponent>,
    @Inject(MAT_DIALOG_DATA) public config: UpgradeCTADialogConfig,
    private sanitizer: DomSanitizer,
  ) {
    this.sanitizedSellingPoints =
      this.config.keySellingPoints?.map((sellingPoint) => this.sanitizeSellingPoint(sellingPoint)) ?? [];
  }

  sanitizeSellingPoint(sellingPoint: string): string {
    return DOMPurify.sanitize(sellingPoint);
  }
}

export interface UpgradeCTADialogConfig {
  imageText?: string;
  imageUrl?: string;
  editionName?: string;
  upgradeNowText?: string;
  price?: string;
  frequency?: string;
  keySellingPoints?: string[];
  templateSellingPoints?: TemplateSellingPoint[];
  ctaText?: string;
  activeOrderPrimaryText?: string;
  activeOrderSecondaryText?: string;
  activeOrderImageUrl?: string;
}

export interface TemplateSellingPoint {
  text: string;
  template: object;
}
